import { render, staticRenderFns } from "./MeasureEdit.vue?vue&type=template&id=b42f959a&scoped=true&"
import script from "./MeasureEdit.vue?vue&type=script&lang=js&"
export * from "./MeasureEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42f959a",
  null
  
)

export default component.exports